import { useLocation } from "react-router-dom";

export type UserMode = "explorer" | "adult" | "admin";

export interface ModeDetectionResult {
  currentMode: UserMode;
  isExplorer: boolean;
  isAdmin: boolean;
  isAdult: boolean;
  getRoute: (path: string) => string;
}

export function useModeDetection(): ModeDetectionResult {
  const location = useLocation();
  const pathname = location.pathname;

  // Determine mode based on route prefix
  let currentMode: UserMode = "adult";
  if (pathname.startsWith("/explorer")) {
    currentMode = "explorer";
  } else if (pathname.startsWith("/admin")) {
    currentMode = "admin";
  }

  const getRoute = (path: string): string => {
    return currentMode === "adult" ? path : `/${currentMode}${path}`;
  };

  return {
    currentMode,
    isExplorer: currentMode === "explorer",
    isAdmin: currentMode === "admin",
    isAdult: currentMode === "adult",
    getRoute,
  };
}
